import { render, staticRenderFns } from "./Fulfillment.vue?vue&type=template&id=237cb162"
import script from "./Fulfillment.vue?vue&type=script&lang=js"
export * from "./Fulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports